import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import UpdateForm from './UpdateForm'
import { PageHeader, StatusBadge } from '../../ui'

export default function AccountRateCodeSetup() {

  const [lgShow, setLgShow] = useState(false);
  const [accessType, setAccessType] = useState('')

  //API call
  useEffect(() => {

    const loggedInUser = sessionStorage.getItem("user_token");
    const foundUser = JSON.parse(loggedInUser);

    if (foundUser.role_capabilities?.all_modules_access === true) {

      setAccessType('Edit');

    }
    else {

      setAccessType(foundUser.access['AccountRateCode_Access Specifier']);
    }

  }, []);

  return (
    <>
      <PageHeader
        title="Account Rate Codes"
        subtitle="Configure the rate groups available to each account."
        eyebrow="Rate setup"
        help={(
          <button type="button" className="btn btn-outline-primary" onClick={() => setLgShow(true)}>
            Help
          </button>
        )}
      >
        {accessType === 'View' && <StatusBadge status="neutral">View only</StatusBadge>}
      </PageHeader>

      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="account-rate-code-help-title"
      >
        <Modal.Header closeButton>
          <Modal.Title id="account-rate-code-help-title">
            Instructions to Add or Edit Account Rate Codes
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5>Add New</h5>
          <ol>
            <li>Select an Account Name. The Account ID and Account Type are generated automatically.</li>
            <li>Select the required rate groups from the OTAs.</li>
            <li>Choose Submit.</li>
          </ol>

          <h5>Existing Records</h5>
          <ol>
            <li>Select the account name.</li>
            <li>Review the existing mapping and make the required changes.</li>
          </ol>
        </Modal.Body>
      </Modal>

      {accessType === 'View' ? <UpdateForm accessType={accessType} /> : <UpdateForm />}


    </>
  );
}
